import { render, staticRenderFns } from "./default-sort-columns-with-template.vue?vue&type=template&id=19b19958&"
import script from "./default-sort-columns-with-template.vue?vue&type=script&lang=js&"
export * from "./default-sort-columns-with-template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports